<template>
  <footer class="portal-footer">
    <div class="portal-footer__top">
      <div class="wrapper px-3">
        <div class="row">
          <div class="col-md-6 col-sm-6">
            <div class="moduletable">
              <div class="custom">
                <div class="services-widget">
                  <div class="logo">
                    <img src="@/assets/img/logo-light-icon.png" alt="improvIT" />
                  </div>
                  <div class="services-list">
                    <div class="row">
                      <div class="col-md-6">
                        <ul>
                          <li><router-link to="/motor" class=""><a href="javascript:;">Motor Insurance</a></router-link></li>
                          <li><router-link to="/driver" class=""><a href="javascript:;">Driver Insurance</a></router-link></li>
                          <li><router-link to="/hunter" class=""><a href="javascript:;">Hunter Insurance</a></router-link></li>
                        </ul>
                      </div>
                      <div class="col-md-6">
                        <ul>
                          <li><router-link to="/home" class=""><a href="javascript:;">Home Insurance</a></router-link></li>
                          <li><router-link to="/travel" class=""><a href="javascript:;">Travel Insurance</a></router-link></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-3 col-sm-6">
            <div class="contact-widget">
              <h3>Contact Us</h3>
              <div class="customcontact-widget">
                <div class="content">
                  <p><strong>A:</strong> Arkadias 3, 115 26 Athens, Greece</p>
                  <p><strong>P:</strong> (+30) 96 716 6879</p>
                  <p><strong>E:</strong> info@improvit.gr</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-3 col-sm-6">
            <div class=" social-widget">
              <h3>Follow us</h3>

              <div class="customsocial-widget">
                <ul class="social-list">
                  <li>
                    <a href="#"><i class="mdi mdi-facebook"></i> </a>
                  </li>
                  <li>
                    <a href="#"><i class="mdi mdi-twitter"></i> </a>
                  </li>
                  <li>
                    <a href="#"><i class="mdi mdi-google-plus"></i> </a>
                  </li>
                  <li>
                    <a href="#"><i class="mdi mdi-linkedin"></i> </a>
                  </li>
                  <li>
                    <a href="#"><i class="mdi mdi-instagram"></i> </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="portal-footer__bottom">
      <div class="wrapper px-3">Developed by <a href="https://www.improvit.gr" target="_blank">improvIT</a>.</div>
    </div>
  </footer>
</template>

<script>
export default {};
</script>
<style lang="scss">
.portal-footer__top {
  padding: 40px 0;
  background-color: $skin5;
}
</style>
